<!--
 * @Description: Description
 * @Author: dpw
 * @Date: 2025-01-216 11:46:23
 * @LastEditors: gaoyuanyuan
 * @LastEditTime: 2026-03-30 11:21:15
-->
<template>
    <div :class="['register-page', $i18n.locale]">
        <div class="navbar">
            <span>
                <img
                    src="@/assets/images/sidebar/arrow-left.png"
                    alt
                    class="menu-info"
                    @click.prevent="onClickLeft()"
                />
            </span>

            <el-dropdown placement="bottom" class="custom-dropdown" @command="onCommand" trigger="click">
                <span class="el-dropdown-language">{{ currentLanguage }}</span>
                <el-dropdown-menu slot="dropdown" class="custom-dropdown-menu">
                    <el-dropdown-item
                        :command="item.label"
                        v-for="(item, index) in languages"
                        :key="index"
                        :disabled="item.label === currentLanguage"
                        >{{ item.label }}</el-dropdown-item
                    >
                </el-dropdown-menu>
            </el-dropdown>
        </div>
        <div class="header">
            <h2>{{ !this.bindStatus ? $t('login.bindEmail') : $t('login.bindPhone') }}</h2>
            <p>{{ $t('login.boundCenterTips3') }}</p>
        </div>
        <!-- 邮箱绑定 -->
        <div v-if="!bindStatus">
            <!-- 邮箱密码登录 -->
            <div class="content" v-if="loginStatus">
                <div class="form">
                    <div class="item">
                        <label for="email" v-if="$i18n.locale === 'tr-TR' || $i18n.locale === 'ar-AR'">{{
                            $t('login.email')
                        }}</label>
                        <label for="email" v-else>E-mail</label>
                        <div class="info">
                            <van-field
                                @blur="handleBlurReset($event)"
                                @focus="handleFouceReset($event)"
                                v-model.trim="form.email"
                                name
                                label
                                :placeholder="$t('login.formList[2].label')"
                                class="iteminput"
                            />
                        </div>
                    </div>
                    <div class="item">
                        <label for="verifyPassword" class="codeLabel codeLabel-item">{{
                            $t('login.account.password')
                        }}</label>
                        <div class="info">
                            <input
                                :style="
                                    $i18n.locale === 'zh-CN'
                                        ? 'padding-left: 50px'
                                        : $i18n.locale === 'es-ES' ||
                                          $i18n.locale === 'it-IT' ||
                                          $i18n.locale === 'tr-TR'
                                        ? 'padding-left: 10px'
                                        : 'padding-left: 20px'
                                "
                                autocomplete="off"
                                ref="verifyPassword"
                                v-model="form.password"
                                @blur="handleBlurReset($event)"
                                @focus="handleFouceReset($event)"
                                @input="validatorPassword"
                                :type="isAppleDevice ? (showPassword ? 'text' : 'password') : 'text'"
                                label
                                :placeholder="$t('login.account.placeholder')"
                                name="verifyPassword"
                                :border="false"
                                :class="[
                                    isAppleDevice ? '' : showPassword ? 'password-visible' : 'password-hidden',
                                    'itemyzm',
                                ]"
                            />

                            <span class="toggle-password" @click="togglePassword">
                                <img
                                    :src="
                                        showPassword
                                            ? require('@/assets/images/eye_show.png')
                                            : require('@/assets/images/eye_off.png')
                                    "
                                    class="eye-icon"
                                />
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 邮箱验证码登录 -->
            <div class="content" v-else>
                <div class="form">
                    <div class="item">
                        <label for="email" v-if="$i18n.locale === 'tr-TR' || $i18n.locale === 'ar-AR'">{{
                            $t('login.email')
                        }}</label>
                        <label for="email" v-else>E-mail</label>
                        <div class="info">
                            <van-field
                                @blur="handleBlurReset($event)"
                                @focus="handleFouceReset($event)"
                                v-model.trim="form.email"
                                name
                                label
                                :placeholder="$t('login.formList[2].label')"
                                class="iteminput"
                            />
                        </div>
                    </div>
                    <div class="item">
                        <label for="verifyCode" class="codeLabel codeLabel-item">
                            {{ $t('login.formList[1].label') }}
                        </label>
                        <div class="info">
                            <div
                                class="placeholder_code"
                                v-if="!isFocus && $i18n.locale === 'ja-JP'"
                                @click="onPlaceholder"
                            >
                                {{ $t('login.formList[1].placeholder') }}
                            </div>
                            <input
                                :style="
                                    $i18n.locale === 'zh-CN'
                                        ? 'padding-left: 50px'
                                        : $i18n.locale === 'es-ES' ||
                                          $i18n.locale === 'it-IT' ||
                                          $i18n.locale === 'tr-TR'
                                        ? 'padding-left: 10px'
                                        : 'padding-left: 20px'
                                "
                                autocomplete="off"
                                ref="verifyCode"
                                v-else
                                :disabled="isCodeInputDisabled"
                                v-model="form.code"
                                @blur="handleBlurReset($event)"
                                @focus="handleFouceReset($event)"
                                @input="validatorCode"
                                type="number"
                                label
                                :placeholder="$i18n.locale === 'ja-JP' ? '' : $t('login.formList[1].placeholder')"
                                name="verifyCode"
                                :border="false"
                                class="itemyzm"
                            />
                            <span
                                :class="{ 'is-disabled': isCodeBtnDisabledEmail }"
                                @click="handleSendCode"
                                class="get-code-btn"
                                >{{ codeText }}</span
                            >
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 手机绑定 -->
        <div v-else>
            <!-- 手机密码登录 -->
            <div class="content" v-if="loginStatus">
                <div class="form">
                    <div class="item">
                        <label for="mobile" @click="selectAreaCode">
                            <div class="area">
                                <span class="no">{{ areaCode }}</span>
                                <i class="arrow_bottom"></i>
                            </div>
                        </label>
                        <div class="info">
                            <van-field
                                autocomplete="off"
                                @blur="handleBlurReset($event)"
                                @focus="handleFouceReset($event)"
                                label
                                name="mobile"
                                type="digit"
                                v-model.trim="form.phone"
                                :placeholder="$t('login.formList[0].label')"
                                :border="false"
                            />
                        </div>
                    </div>
                    <div class="item">
                        <label class="codeLabel codeLabel-item" for="verifyPassword">{{
                            $t('login.account.password')
                        }}</label>
                        <div class="info">
                            <input
                                :style="
                                    $i18n.locale === 'zh-CN' || $i18n.locale === 'zh-TW' || $i18n.locale === 'zh-HK'
                                        ? 'padding-left: 50px'
                                        : $i18n.locale === 'es-ES' ||
                                          $i18n.locale === 'it-IT' ||
                                          $i18n.locale === 'tr-TR'
                                        ? 'padding-left: 10px'
                                        : 'padding-left: 10px'
                                "
                                autocomplete="off"
                                ref="verifyPassword"
                                v-model="form.password"
                                @blur="handleBlurReset($event)"
                                @focus="handleFouceReset($event)"
                                @input="validatorPassword"
                                :type="isAppleDevice ? (showPassword ? 'text' : 'password') : 'text'"
                                label
                                :placeholder="$t('login.account.placeholder')"
                                name="verifyPassword"
                                :border="false"
                                :class="isAppleDevice ? '' : showPassword ? 'password-visible' : 'password-hidden'"
                            />
                            <span class="toggle-password" @click="togglePassword">
                                <img
                                    :src="
                                        showPassword
                                            ? require('@/assets/images/eye_show.png')
                                            : require('@/assets/images/eye_off.png')
                                    "
                                    class="eye-icon"
                                />
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 手机验证码登录 -->
            <div class="content" v-else>
                <div class="form">
                    <div class="item">
                        <label for="mobile" @click="selectAreaCode">
                            <div class="area">
                                <span class="no">{{ areaCode }}</span>
                                <i class="arrow_bottom"></i>
                            </div>
                        </label>
                        <div class="info">
                            <van-field
                                autocomplete="off"
                                @blur="handleBlurReset($event)"
                                @focus="handleFouceReset($event)"
                                label
                                name="mobile"
                                type="digit"
                                v-model.trim="form.phone"
                                :placeholder="$t('login.formList[0].label')"
                                :border="false"
                            />
                        </div>
                    </div>
                    <div class="item">
                        <label class="codeLabel codeLabel-item" for="verifyCode">
                            {{ $t('login.formList[1].label') }}
                        </label>
                        <div class="info">
                            <div
                                class="placeholder_code"
                                v-if="!isFocus && $i18n.locale === 'ja-JP'"
                                @click="onPlaceholder"
                            >
                                {{ $t('login.formList[1].placeholder') }}
                            </div>
                            <input
                                :style="
                                    $i18n.locale === 'zh-CN'
                                        ? 'padding-left: 50px'
                                        : $i18n.locale === 'es-ES' ||
                                          $i18n.locale === 'it-IT' ||
                                          $i18n.locale === 'tr-TR'
                                        ? 'padding-left: 10px'
                                        : 'padding-left: 20px'
                                "
                                autocomplete="off"
                                ref="verifyCode"
                                v-else
                                :disabled="isCodeInputDisabled"
                                v-model="form.code"
                                @blur="handleBlurReset($event)"
                                @focus="handleFouceReset($event)"
                                @input="validatorCode"
                                type="number"
                                label
                                :placeholder="$i18n.locale === 'ja-JP' ? '' : $t('login.formList[1].placeholder')"
                                name="verifyCode"
                                :border="false"
                            />
                            <span
                                :class="{ 'is-disabled': isCodeBtnDisabled }"
                                @click="handleSendCode"
                                class="get-code-btn"
                                >{{ codeText }}</span
                            >
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 底部 -->
        <div class="footer">
            <div class="login-tool">
                <div class="left-view">
                    <img
                        :src="
                            require(loginStatus
                                ? '@/assets/images/login/toggle_button_1.png'
                                : '@/assets/images/login/toggle_button.png')
                        "
                        class="image"
                        @click="switchLoginType"
                    />
                    <div @click="switchLoginType" :class="[{ 'is-code': loginStatus }, 'name']">
                        {{ switchButtonName }}
                    </div>
                </div>

                <div v-if="loginStatus" class="name-view" style="margin-right: 10px" @click="forgotPassword">
                    {{ $t('login.account.forgotPassword') }}
                </div>
                <!-- <template v-else>
                    <span v-if="!bindStatus" :class="{ 'is-disabled': isCodeBtnDisabledEmail }" @click="handleSendCode"
                                class="get-code-btn">{{ codeText }}</span>
                    <span v-else :class="{ 'is-disabled': isCodeBtnDisabled }" @click="handleSendCode" class="get-code-btn">{{
                    codeText }}</span>
                </template>-->
            </div>

            <div class="submit-btn">
                <div class="error-tips" v-if="erorTips">{{ erorTips }}</div>
                <van-button
                    :disabled="isMobileSubmitDisabled"
                    :class="{
                        'is-disabled': isMobileSubmitDisabled,
                        'custom-btn': true,
                    }"
                    @click.prevent="bindLogin"
                    @keyup.enter="bindLogin"
                    type="primary"
                    color="linear-gradient(90deg, #00E3C9 0%, #009FE8 100%)"
                    >{{ $t('login.account.accountTitle') }}</van-button
                >
            </div>
        </div>
        <!-- 自动登录 -->
        <div class="automatic-login" @click="isAutoLogin = !isAutoLogin">
            <span :class="[{ 'is-check': isAutoLogin }, 'checkbox']">
                <input type="checkbox" v-model="isAutoLogin" />
            </span>
            <i>{{ $t('login.autoLogin') }}</i>
        </div>

        <!-- 其他登录方式 -->
        <div class="third-view">
            <div class="line-view">
                <div class="line"></div>
                <div class="tips-view">{{ $t('login.bindLineTips') }}</div>
                <div class="line"></div>
            </div>

            <div class="third-login">
                <div :class="[{ 'is-code': !loginStatus }, 'name']" @click="switchBindClick()">
                    {{ !this.bindStatus ? $t('login.bindPhone') : $t('login.bindEmail') }}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { bindOldMember, sendValidationEmail, sendValidationCode } from '@/assets/js/apolloGql.js'
import { singleCryptographicCheck, encryptPassword, cryptographicCheck } from '@/assets/js/util.js'
import { languageConfig, languageConfigM60 } from '@/assets/js/langObject'
import { isM60 } from '@/types/device.js'

export default {
    components: {},
    data() {
        return {
            isFocus: false,
            erorTips: '',
            isAutoLogin: false,
            areaCode: '',
            currentLanguage: '',
            languages: isM60() ? languageConfigM60 : languageConfig,
            form: {
                code: '',
                phone: '',
                email: '',
            },
            height: {
                isValid: false,
                value: '',
            },
            // 验证码定时器
            timer: '',
            // 获取验证码时间间隔 60s
            countDown: 60,
            codeText: '',
            // 验证码默认不能输入 验证码发送成功后才能输入
            isCodeInputDisabled: false,
            // 验证码是否正在发送状态
            isCodeSending: false,
            outTimeStamp: 0,
            // 提交按钮状态
            submitDisabled: false,
            loginInfo: JSON.parse(window.localStorage.getItem('loginInfo')),
            // 选择登录状态
            loginStatus: false,
            bindStatus: false, //  false 邮箱绑定  true手机号绑定
            timeTag: null,
            // 登录按钮是否正在加载中
            loginBtnState: false,
            showPassword: false, // 用于控制密码显示/隐藏
            isMobileSubmitDisabled: true,
        }
    },

    computed: {
        isAppleDevice() {
            return /Mac|iPhone|iPad|iPod/i.test(navigator.userAgent)
        },
        // 是否禁用获取验证码按钮 手机号长度不对|正在倒计时|验证码已发送等待返回
        isCodeBtnDisabled() {
            return !this.form.phone || this.form.phone.length < 5 || this.form.phone.length > 15 || this.isCodeSending
        },
        isCodeBtnDisabledEmail() {
            return !this.form.email || this.isCodeSending
        },
        // 是否禁用登录按钮
        // isMobileSubmitDisabled() {
        //     return this.form.code.length !== 4
        // },
        // 是否禁用用户信息注册按钮
        isSubmitDisabled() {
            return this.birthday.isValid === false || this.height.isValid === false
        },
        userAgent() {
            const ua = navigator.userAgent
            return {
                ua: ua,
                isAndroid: ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1,
                isiOS: !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
            }
        },
        switchButtonName() {
            let name = this.$t('')
            if (this.bindStatus) {
                // 手机
                if (!this.loginStatus) {
                    name = this.$t('login.phonePassword')
                } else {
                    name = this.$t('login.phoneCode')
                }
            } else {
                // 邮箱
                if (!this.loginStatus) {
                    name = this.$t('login.emailPassword')
                } else {
                    name = this.$t('login.emailCode')
                }
            }
            return name
        },
    },

    watch: {},

    beforeDestroy() {
        clearInterval(this.timer)
    },
    created() {
        // 默认语言配置
        const lang = localStorage.getItem('lang')
        if (!lang) {
            localStorage.setItem('lang', 'en-US')
        }

        this.codeText = this.$t('login.formList[0].placeholder')
        this.areaCode = this.languages.find((item) => item.value === this.$i18n.locale)?.no
        this.currentLanguage = this.languages.find((item) => item.value === this.$i18n.locale)?.label
    },
    mounted() {
        // 保留信息不被清空
        const lookUserInfo = JSON.parse(window.localStorage.getItem('lookUserInfo'))
        if (lookUserInfo) {
            this.form.phone = lookUserInfo.phone
            this.form.code = lookUserInfo.code
            this.form.email = lookUserInfo.email
            this.countDownTime = lookUserInfo.countDownTime || 0
            this.isCodeInputDisabled = false
            const time = new Date().getTime() - this.countDownTime
            if (time < 60000) {
                this.isCodeSending = true
                this.countDown = 60 - Math.floor(time / 1000)
                this.countDownAction()
            }
        }
    },

    methods: {
        mobileSubmitDisabled() {
            console.log(`=======${this.loginStatus}`)
            if (!this.loginStatus) {
                this.isMobileSubmitDisabled = this.form.code.length !== 4
            }
            if (this.loginStatus) {
                this.isMobileSubmitDisabled = !cryptographicCheck(this.form.password)
            }
        },
        onPlaceholder() {
            this.isFocus = true
            this.$nextTick(() => {
                console.log(this.$refs.verifyCode)
                this.$refs.verifyCode.focus()
            })
        },
        togglePassword() {
            this.showPassword = !this.showPassword
        },

        onClickLeft() {
            this.$router.go(-1)
        },
        validatorPassword() {
            const newPassword = event.target.value.replace(/[\u4e00-\u9fa5]/g, '')
            // 使用 Vue.set 确保响应式更新
            this.$set(this.form, 'password', newPassword)
            this.$nextTick(() => {
                if (this.form.password.length < 4) {
                    this.erorTips = ''
                    return
                }
                const data = singleCryptographicCheck(this.form.password)
                if (!data.length) {
                    this.erorTips = this.$t('login.account.checkRule[0]')
                } else if (!data.uppercase) {
                    this.erorTips = this.$t('login.account.checkRule[1]')
                } else if (!data.lowercase) {
                    this.erorTips = this.$t('login.account.checkRule[2]')
                } else if (!data.digit) {
                    this.erorTips = this.$t('login.account.checkRule[3]')
                } else {
                    this.erorTips = ''
                }
            })
            this.mobileSubmitDisabled()
        },

        // 切换密码验证登录
        switchLoginType() {
            this.erorTips = ''
            this.loginStatus = !this.loginStatus
            this.isMobileSubmitDisabled = true
            this.form.code = ''
            this.form.password = ''
        },
        // 选择地区国家
        selectAreaCode() {
            this.showAreaCodeSelect = true
        },
        onCommand(lang) {
            let languageInfo = {}
            for (let index = 0; index < this.languages.length; index++) {
                if (lang === this.languages[index].label) {
                    languageInfo = this.languages[index]
                    break
                }
            }
            this.$i18n.locale = languageInfo.value
            this.areaCode = languageInfo?.no
            localStorage.setItem('lang', this.$i18n.locale)
            this.currentLanguage = lang
            this.codeText = this.$t('login.formList[0].placeholder')
            this.erorTips = ''
            this.form.phone = ''
            this.form.code = ''
            this.form.email = ''
            this.form.password = ''
        },
        // 失去焦点后重置背景
        handleBlurReset(e) {
            const phone = this.form.phone
            const email = this.form.email
            if (phone === '' || email === '') {
                if (this.bindStatus && phone === '') {
                    this.$toast({
                        message: this.$t('login.formList[0].label'),
                        duration: 1500,
                    })
                    return
                } else if (!this.bindStatus && email === '') {
                    this.$toast({
                        message: this.$t('login.formList[2].label'),
                        duration: 1500,
                    })
                    return
                }
            }
            if (this.bindStatus) {
                if (phone.length < 5 || phone.length > 15) {
                    this.erorTips = this.$t('login.rule.phone.requiredMsg')
                } else {
                    this.erorTips = ''
                }
            } else {
                // eslint-disable-next-line no-useless-escape
                const email =/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                if (!email.test(this.form.email)) {
                    this.erorTips = this.$t('login.rule.email.requiredMsg')
                } else {
                    this.erorTips = ''
                }
            }

            if (this.form.code === '') {
                this.isFocus = false
            }
            this.outTimeStamp = e.timeStamp
            this.mobileSubmitDisabled()
            setTimeout(() => {
                if (this.outTimeStamp === e.timeStamp) {
                    this.resetBackground()
                }
            }, 100)
        },

        handleFouceReset(e) {
            this.outTimeStamp = e.timeStamp
            this.mobileSubmitDisabled()
        },

        // 重置iso下键盘收回后底部空白问题
        resetBackground() {
            window.scrollTo(0, 0)
        },
        validateForm() {
            let err

            if (!this.loginStatus && !this.form.code) {
                // 请输入验证码
                err = this.$t('login.formList[1].placeholder')
            }

            // 判断验证码少于4位
            if (!this.loginStatus && this.form.code && this.form.code.length < 4) {
                err = this.$t('login.rule.authCode.requiredMsg')
            }
            if (!this.form.phone && !this.form.email) {
                if (this.loginStatus) {
                    err = this.$t('login.formList[0].label')
                } else {
                    err = this.$t('login.formList[2].label')
                }
            } else {
                if (this.bindStatus) {
                    const reg = /^[0-9]*$/
                    if (!reg.test(this.form.phone)) {
                        err = this.$t('login.rule.phone.requiredMsg')
                    }
                } else {
                    // eslint-disable-next-line no-useless-escape
                    const email =/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    if (!email.test(this.form.email)) {
                        err = this.$t('login.rule.email.requiredMsg')
                    }
                }
            }
            if (err) {
                this.erorTips = err
                return false
            }
            return true
        },
        // 倒计时
        countDownAction() {
            this.countDownTime = new Date().getTime()
            let that = this
            this.timeTag = setInterval(() => {
                that.countDown--
                that.codeText = `${this.$t('login.retransmission', { item: that.countDown })}`
                if (that.countDown === 0) {
                    that.isCodeSending = false
                    that.codeText = this.$t('login.formList[0].placeholder')
                    clearInterval(this.timeTag)
                    that.countDown = 60
                }
            }, 1000)
            this.timer = this.timeTag
        },

        // 发送验证码
        async handleSendCode() {
            let that = this

            // 判断按钮状态 禁用时不可点击
            if (this.isCodeBtnDisabled && this.bindStatus) {
                return
            } else if (this.isCodeBtnDisabledEmail && !this.bindStatus) {
                return
            }
            if (!this.form.phone && this.bindStatus) {
                this.erorTips = this.$t('login.formList[0].label')
                return
            }
            that.form.code = ''
            const reg = /^[0-9]*$/
            // eslint-disable-next-line no-useless-escape
            const email =/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            if (this.countDown === 60) {
                if (!reg.test(this.form.phone) && this.bindStatus) {
                    this.erorTips = this.$t('login.rule.phone.requiredMsg')
                } else if (!email.test(this.form.email) && !this.bindStatus) {
                    this.erorTips = this.$t('login.rule.email.requiredMsg')
                } else {
                    // const flag = await this.handleVerifyNewUser()
                    // if (!flag) return this.jumpRegis();
                    this.isCodeSending = true
                    // 验证码发送成功后可输入验证码
                    this.isCodeInputDisabled = false

                    if (this.bindStatus) {
                        let scanId = ''
                        if (this.$route.query.redirect) {
                            let index = this.$route.query.redirect.indexOf('scan_id') // 获取指定字符的位置
                            if (index !== -1) scanId = this.$route.query.redirect.substring(index + 8) // 截取指定字符后面的内容
                            if (scanId.split('&').length > 1) scanId = scanId.split('&')[0]
                            console.log(1111111111, scanId)
                        }
                        // 去除手机号中的所有前导零
                        let cleanedPhone = this.form.phone.replace(/^0+/, '')
                        this.$apollo
                            .mutate({
                                mutation: sendValidationCode,
                                variables: {
                                    mobile: this.areaCode + cleanedPhone,
                                    scanId: scanId,
                                },
                            })
                            .then((res) => {
                                const data = res.data.sendValidationCode
                                if (data.code === 200) {
                                    this.countDownAction()
                                    this.$toast({
                                        message: this.$t('login.success'),
                                        duration: 1500,
                                        className: 'success-toast',
                                    })
                                } else if (data.code === 404) {
                                    // 手机号未注册提示文案
                                    this.erorTips = this.$t('login.rule.phone.patternMsg')
                                } else {
                                    this.isCodeSending = false
                                    this.$toast({
                                        message: this.$t('login.error'),
                                        duration: 2000,
                                        className: 'success-toast',
                                    })
                                }
                            })
                            .catch((err) => {
                                console.error(err)
                                this.isCodeSending = false
                            })
                    } else {
                        this.$apollo
                            .mutate({
                                mutation: sendValidationEmail,
                                variables: {
                                    email: this.form.email,
                                },
                            })
                            .then((res) => {
                                const data = res.data.sendValidationEmail
                                if (data.code === 200) {
                                    this.countDownAction()
                                    this.$toast({
                                        message: this.$t('login.success'),
                                        duration: 2000,
                                        className: 'success-toast',
                                    })
                                } else if (data.code === 404) {
                                    // 邮箱未注册提示文案
                                    this.erorTips = this.$t('login.rule.email.patternMsg')
                                } else {
                                    this.isCodeSending = false
                                    this.$toast({
                                        message: this.$t('login.error'),
                                        duration: 1500,
                                        className: 'success-toast',
                                    })
                                }
                            })
                            .catch((err) => {
                                console.error(err)
                                this.isCodeSending = false
                            })
                    }
                }
            }
        },
        // 绑定登录
        bindLogin() {
            if (!this.isMobileSubmitDisabled && this.validateForm() && !this.loginBtnState) {
                this.loginBtnState = true
                let mobile = ''
                if (this.form.phone) {
                    // 去除手机号中的所有前导零
                    let cleanedPhone = this.form.phone.replace(/^0+/, '')
                    mobile = this.areaCode + cleanedPhone
                }

                const thirdLoginInfo = JSON.parse(window.localStorage.getItem('thirdLoginInfo'))
                if (!thirdLoginInfo) {
                    this.erorTips = this.$t('login.bindError[0]')
                    return
                }

                this.$apollo
                    .mutate({
                        mutation: bindOldMember,
                        variables: {
                            thirdMember: {
                                mobile: mobile,
                                email: this.form.email,
                                password: this.form.password ? encryptPassword(this.form.password) : null,
                                smsCode: String(this.form.code) || '',
                                nickname: thirdLoginInfo.nickname,
                                picture: thirdLoginInfo.picture,
                                code: thirdLoginInfo.code,
                                identifier: thirdLoginInfo.identifier,
                                type: thirdLoginInfo.type,
                            },
                        },
                    })
                    .then((res) => {
                        const data = res.data.bindOldMember
                        console.log(data)
                        // 老用户 已有用户信息
                        if (data.code === 200) {
                            window.localStorage.removeItem('modelInfo')
                            window.localStorage.removeItem('thirdLoginInfo')
                            window.localStorage.removeItem('lookUserInfo')
                            window.localStorage.setItem(
                                'loginInfo',
                                JSON.stringify({
                                    mobile: mobile,
                                    email: this.form.email,
                                })
                            )
                            // 保存token
                            sessionStorage.setItem('token', data.data.token)
                            // 下次自动登录
                            if (this.isAutoLogin) {
                                // 设置自动登录
                                localStorage.setItem('token', data.data.token)
                            }
                            if (this.form.email && this.form.email.length > 0) {
                                localStorage.setItem('email', this.form.email)
                            } else {
                                localStorage.removeItem('email')
                            }
                            this.$toast({
                                message: this.$t('login.loginSuccess'),
                                duration: 1500,
                                className: 'success-toast',
                            })
                            setTimeout(() => {
                                this.loginBtnState = false
                                // 默认跳转到报告页面
                                let path = '/report'
                                // 如果是从别的页面跳转过来的，跳到之前的页面
                                if (localStorage.getItem('redirect')) {
                                    path = localStorage.getItem('redirect') // 跳到之前的页面
                                }
                                this.$router.push({
                                    path: path,
                                })
                            }, 2000)
                        } else if (data.code === 403) {
                            // 密码错误
                            console.log(`${data.message}`)
                            this.loginBtnState = false
                            this.erorTips = this.$t('login.account.errorTips[0]')
                        } else if (data.code === 404) {
                            // 没有注册 账号不存在，
                            this.loginBtnState = false
                            this.erorTips = this.$t('login.account.errorTips[2]')
                        } else if (data.code === 413) {
                            // 验证码错误
                            this.loginBtnState = false
                            this.erorTips = this.$t('login.rule.authCode.requiredMsg')
                        } else if (data.code === 414) {
                            // 账号不存在
                            this.loginBtnState = false
                            this.erorTips = this.$t('login.bindError[6]')
                        } else if (data.code === 415) {
                            // 用户绑定过其他账号
                            this.loginBtnState = false
                            let name = ''
                            if (thirdLoginInfo.type === 2) {
                                name = 'Facebook'
                            } else if (thirdLoginInfo.type === 1) {
                                name = 'Google'
                            }
                            this.erorTips = this.$t('login.bindError[7]', { item: name, nickname: data.data.nickname })
                        } else {
                            this.loginBtnState = false
                            this.erorTips = this.$t('login.account.errorTips[1]')
                        }
                    })
                    .catch(() => {
                        this.loginBtnState = false
                    })
            }
        },
        // 切换绑定方式
        switchBindClick() {
            // 进入绑定手机界面
            if (!this.bindStatus) {
                this.bindStatus = true
                this.loginStatus = true
            } else {
                this.bindStatus = false
                this.loginStatus = false
            }
            clearInterval(this.timer)
            this.countDown = 60
            this.isCodeSending = false
            this.codeText = this.$t('login.formList[0].placeholder')
        },

        // 判断验证码长度
        validatorCode() {
            const code = this.form.code.replace(/\s*/g, '')
            if (code.length > 4) {
                this.form.code = code.substring(0, 4)
            }
            this.mobileSubmitDisabled()
        },
        // 忘记密码
        forgotPassword() {
            this.$router.push({
                path: '/resetPassword',
                query: {
                    redirect: this.$route.query.redirect || '/exception/report',
                    type: 'forgotPassword',
                    user_id: this.$route.query.user_id,
                }, // 'to.fullPath'跳转到登录之前页面的路径
            })
        },
    },
}
</script>

<style scoped lang="less">
.register-page {
    flex: 1;
    width: 100%;
    height: 100%;
    padding-top: 15px;
    background-image: linear-gradient(180deg, #262849, #07090f);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    // justify-content: space-between;
    justify-content: initial;
    overflow: scroll;

    .areaCode {
        z-index: 999;
    }

    .navbar {
        width: 100%;
        height: 30px;
        padding-right: 45px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .menu-info {
            width: 24px;
            height: 24px;
            margin-left: 8px;
        }

        /deep/ .van-icon-arrow-left:before {
            font-size: 14px;
            color: #fff;
        }
    }

    .el-dropdown-language {
        font-size: 12px;
        color: #fff;

        &::after {
            content: '';
            position: absolute;
            top: 55%;
            right: -14px;
            transform: translateY(-80%);
            width: 0;
            height: 0;
            border-left: 4px solid transparent;
            border-right: 4px solid transparent;
            border-top: 4px solid #fff;
        }
    }

    .header {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-top: 30px;

        h2 {
            height: 30px;
            mix-blend-mode: initial;
            color: #ffffff;
            font-family: PingFangSC;
            font-size: 21px;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.14;
            letter-spacing: normal;
            text-align: center;
            -webkit-background-clip: text;
            background-clip: text;
            // -webkit-text-fill-color: transparent;
        }

        p {
            width: 300px;
            height: 34px;
            font-family: PingFangSC;
            mix-blend-mode: initial;
            font-size: 12px;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.5;
            letter-spacing: normal;
            text-align: center;
            color: #8aa3be;
            margin-top: 8px;
            margin-bottom: 34px;
        }
    }

    &.fi-FI {
        .header h2 {
            font-size: 20px;
        }
    }

    /deep/ .content .form .item {
        input:-internal-autofill-previewed,
        input:-internal-autofill-selected {
            -webkit-text-fill-color: #ffffff !important;
            transition: background-color 5000s ease-in-out 0s !important;
        }
    }

    .content {
        // flex: 1;
        // 表单
        .form {
            width: 100%;
            height: auto;

            .item {
                width: 345px;
                height: 56px;
                margin: 0 auto;
                border-radius: 4px;
                // background-color: #232440;
                background: #303c5c;
                padding: 0 16px;
                color: rgba(255, 255, 255, 1);
                margin-bottom: 8px;
                box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.24);
                display: flex;
                align-items: center;
                box-sizing: border-box;

                .area {
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    .no {
                        margin-right: 7px;
                    }

                    .arrow_bottom {
                        width: 0;
                        height: 0;
                        border-left: 6px solid transparent;
                        border-right: 6px solid transparent;
                        border-top: 6px solid #fff;
                    }
                }

                .info {
                    position: relative;
                    flex: 1;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    /deep/ .van-field {
                        padding-left: 0;
                        // background-color: #232440;
                        background: #303c5c;
                    }

                    /deep/ .van-field__control {
                        color: #fff;
                        margin-left: 30px;
                        padding-left: 0px;
                    }

                    /deep/ .van-field__control::placeholder {
                        color: #6c6c6f;
                        font-size: 13.5px;
                    }

                    &.center {
                        justify-content: center;
                    }

                    .over {
                        position: absolute;
                        z-index: 10;
                        width: 100%;
                        height: 56px;
                        font-size: 14px;
                        color: rgba(255, 255, 255, 0.5);
                        line-height: 56px;
                        // pointer-events: none;
                        background-color: #303c5c;
                    }

                    .toggle-password {
                        .eye-icon {
                            width: 20px;
                            height: 20px;
                        }
                    }
                }

                label {
                    font-size: 14px;
                    text-align: left;
                }

                input {
                    width: 100%;
                    height: 56px;
                    background: transparent;
                    // padding-left: 46px;
                    font-size: 14px;
                    color: #fff;
                }

                .password-visible {
                    color: #fff;
                }

                .password-hidden {
                    //解决小米安全键盘回收留白底（防止调用安全键盘使用‘text’）
                    -webkit-text-security: disc;
                    text-security: disc;
                }

                /deep/ .van-field__control {
                    margin-left: 46px;
                }

                input[name='height'] ~ span {
                    font-size: 12px;
                    line-height: 12px;
                    color: rgba(255, 255, 255, 0.5);
                }

                .sex {
                    display: inline-block;
                    opacity: 0.5;
                    width: 40px;
                    height: 24px;
                    font-size: 14px;
                    line-height: 24px;
                    text-align: center;
                    margin: 0 20px;
                    border-radius: 4px;
                    border: 1px solid rgba(255, 255, 255, 1);

                    &.is-active {
                        opacity: 1;
                    }
                }

                .get-code-btn {
                    min-width: fit-content;
                    font-size: 12px;
                    color: #fff;

                    &.is-disabled {
                        opacity: 0.5;
                    }
                }
            }
        }
    }

    .footer {
        .login-tool {
            display: flex;
            width: 315px;
            flex-direction: row;
            justify-content: space-between;
            align-items: flex-start;
            margin-left: 14px;
            .left-view {
                width: 180px;
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: flex-start;
                text-align: left;
                .name {
                    font-size: 12px;
                    font-family: PingFangSC;
                    font-weight: 400;
                    color: #4a90e2;
                    margin-left: 5px;
                    &.is-code {
                        color: #8aa3beff;
                    }
                }
            }
            .name-view {
                width: 150px;
                font-size: 12px;
                font-family: PingFangSC;
                font-weight: 400;
                color: #4a90e2;
                margin-left: 5px;
                text-align: right;
            }

            .get-code-btn {
                width: 150px;
                text-align: right;
                font-size: 12px;
                color: #4a90e2;

                &.is-disabled {
                    opacity: 0.5;
                }
            }

            .image {
                width: 16px;
                height: 16px;
            }
        }

        .opacity {
            opacity: 0;
        }

        // 提交按钮
        .submit-btn {
            position: relative;
            margin-top: 32px;

            .error-tips {
                position: absolute;
                top: -25px;
                left: 50%;
                transform: translateX(-50%);
                font-size: 12px;
                color: #fe6363;
            }

            .create-account {
                text-align: center;
                font-size: 14px;
                color: #4a90e2;
                margin-top: 16px;
            }

            button {
                width: 200px;
                height: 40px;
                outline: none;
                border-radius: 6px;
                background-image: -webkit-gradient(linear, left top, right top, from(#00e3c9), to(#009fe8));
                background-image: -webkit-linear-gradient(left, #00e3c9, #009fe8);
                background-image: -o-linear-gradient(left, #00e3c9, #009fe8);
                background-image: linear-gradient(to right, #00e3c9, #009fe8);
                font-size: 16px;
                color: #fff;

                &.is-disabled {
                    border: 1px solid transparent;
                    background-image: linear-gradient(#191b31, #191b31),
                        /* 底色，即原有的背景 */ linear-gradient(to right, #06b0a2, #067eb9);
                    /* 模拟渐变边框 */
                    background-clip: padding-box, border-box;
                    background-origin: border-box;
                }

                .spinnerBtn {
                    display: flex;
                    justify-content: center;
                }

                /deep/ .mint-spinner-snake {
                    border: 2px solid transparent;
                }

                &.custom-btn {
                    width: 345px;
                    height: 40px;
                    background: linear-gradient(90deg, #00e3c9 0%, #009fe8 100%);
                    border-radius: 6px;
                    margin-top: 20px;
                }
            }
        }
    }

    .automatic-login {
        color: #fff;
        height: auto;
        font-size: 12px;
        display: flex;
        align-items: center;
        margin-top: 18px;

        i {
            font-style: normal;
            color: #8aa3be;
        }

        .checkbox {
            position: relative;
            height: 14px;
            width: 14px;
            border-radius: 50%;
            margin-right: 5px;
            border: 1px solid #fff;

            input {
                height: 12px;
                width: 12px;
                border-radius: 50%;
                opacity: 0;
            }

            &.is-check {
                &:before {
                    position: relative;
                    content: '';
                    height: 14px;
                    width: 14px;
                    margin: -1px;
                    border-radius: 50%;
                    // background: #00a4e6;
                    display: block;
                    overflow: hidden;
                    background: url('../../assets/images/comp_rb.png') no-repeat;
                    background-size: 100% 100%;
                }
            }
        }

        span {
            color: #4a90e2;
        }
    }

    .third-view {
        display: flex;
        flex-direction: column;
        margin-top: 56px;
        .line-view {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            .line {
                width: 127px;
                height: 1px;
                background-image: linear-gradient(
                    to right,
                    rgba(0, 227, 201, 0.2),
                    /* #00e3c9 透明度 20% */ rgba(0, 159, 232, 0.2) /* #009fe8 透明度 20% */
                );
            }
            .tips-view {
                font-size: 12px;
                color: #8aa3be;
                margin: 0 10px 0 10px;
            }
        }
        .third-login {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            margin-top: 24px;
            .name {
                font-size: 12px;
                color: #0091ff;
                &.is-code {
                    color: #8aa3beff;
                }
            }
        }
    }

    .icon-del {
        float: right;
        width: 9.5px;
        height: 9.5px;
        border-radius: 0.8px;
        background: url('../../assets/images/register/register_phone_delete.png') no-repeat;
    }

    .tips {
        position: relative;
        display: inline-block;
        font-size: 12px;
        height: 12px;
        line-height: 12px;
        min-width: 10px;
        color: #ffffff;
        margin-bottom: 30px;

        &::before {
            content: '*';
            position: absolute;
            width: 5px;
            left: -8px;
            top: 2px;
        }
    }

    &.ja-JP {
        .header p {
            width: 280px;
            line-height: 17px;
            margin-top: 20px;
        }

        .header {
            h2 {
                width: 268px;
            }
        }

        /deep/ .content .form .item {
            .get-code-btn {
                min-width: 60px;
                text-align: left;
            }
        }

        /deep/ .item:nth-child(2) {
            .van-field__control {
                margin-left: 22px;
            }
        }

        /deep/ input[name='verifyPassword'] {
            width: 104px;
            line-height: 20px;
            white-space: normal;
            word-break: break-all;
            word-wrap: break-word;
        }

        div .error-tips {
            width: 314px;
            height: 34px;
        }

        /deep/ .van-cell__value {
            margin-left: 0px;
            text-align: left;
        }

        .custom-btn {
            margin-top: 10px !important;
        }
    }

    &.en-US,
    &.it-IT,
    &.fr-FR,
    &.ru-RU,
    &.es-ES,
    &.pt-PT,
    &.tr-TR,
    &.el-GR,
    &.cs-CZ,
    &.sv-SE,
    &.hu-HU,
    &.de-DE {
        .header p {
            width: 312px;
            line-height: 17px;
        }

        .checkbox {
            border: 1px solid #8aa3be !important;
        }

        i {
            color: #8aa3be;
        }

        .submit-btn {
            .error-tips {
                width: 300px;
            }
        }
    }

    &.es-ES,
    &.pt-PT {
        .codeLabel {
            width: 70px;
        }
    }

    &.pl-PL {
        .header p {
            width: 312px;
            line-height: 17px;
        }

        .checkbox {
            border: 1px solid #8aa3be !important;
        }

        i {
            color: #8aa3be;
        }

        .submit-btn {
            .error-tips {
                width: 300px;
            }
        }

        .content .form .item > label.codeLabel.codeLabel-item {
            width: max-content !important;
            min-width: 120px !important;
            max-width: none !important;
            flex: 0 0 auto !important;
            flex-shrink: 0 !important;
            white-space: nowrap !important;
            box-sizing: border-box;
        }
    }

    &.pt-PTO {
        .codeLabel-item {
            width: 80px;
        }
    }

    &.el-GR {
        .header p {
            width: 280px;
            line-height: 17px;
            margin-top: 23px;
        }
        .form .item input {
            font-size: 12px;
        }
    }

    &.ar-AR {
        direction: rtl;

        .iteminput {
            direction: ltr;
        }

        .itemyzm {
            direction: ltr;
            text-align: right;
        }

        .header {
            p {
                text-align: right;
            }
        }

        .search {
            padding-right: 10px;
        }

        /deep/.el-dropdown {
            margin-left: 20px;
        }

        /deep/.van-field__control {
            text-align: right;
        }

        .content .form .item input,
        .footer .rule i,
        .content .form .item .area .arrow_bottom {
            margin-right: 10px;
        }

        .footer .login-tool {
            margin-right: 14px;
        }

        .footer .login-tool .name-view {
            text-align: left;
            margin-left: 0px;
        }

        .footer .login-tool .get-code-btn {
            text-align: left;
        }

        .item .info .van-field__body {
            direction: ltr;
        }
        .right-text-left {
            margin-left: 10px;
        }
    }
    &.hu-HU,
    &.sv-SE {
        .content .item {
            padding-right: 0;
        }
        .get-code-btn {
            min-width: 40px !important;
        }
    }
}
</style>
<style>
/deep/.register-page {
    background-image: linear-gradient(180deg, #262849, #07090f) !important;
}

input[type='number'] {
    -moz-appearance: textfield;
}

input:-webkit-autofill {
    box-shadow: 0 0 0 1000px #303c5c inset;
    -webkit-text-fill-color: #fff;
}

input:-internal-autofill-previewed,
input:-internal-autofill-selected {
    -webkit-text-fill-color: #303c5c;
    transition: background-color 5000s ease-out 0.5s;
}

::-webkit-input-placeholder {
    color: #6c6c6f;
}

::-moz-placeholder {
    /* Firefox 19+ */
    color: #6c6c6f;
}

:-ms-input-placeholder {
    /* IE 10+ */
    color: #6c6c6f;
}

:-moz-placeholder {
    color: #6c6c6f;
}
</style>
